var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gat-form',[_c('gat-group',{attrs:{"title":"Budsjett avvik","collapsed":false}},[_c('v-layout',{attrs:{"wrap":""}},[_c('gat-grid',{attrs:{"columns":_vm.topCatCols,"items":_vm.topCategoryAmounts},on:{"row-clicked":_vm.showAccountDash}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }